import React, { Component } from 'react';
import { getText } from '../config';

class TextInputLabel extends Component {
    constructor(props) {
        super(props)
    }

    createMarkup(text) {
        return {__html: text};
    }

    render() {
        let className = "text-input";
        if(this.props.margin) className = className + " with-margin";
        if(this.props.subText) className = className + " with-sub";
        if(this.props.error) className = className + " error";
        return (
            <div className={className} onClick={this.props.clickHandler}>
                {this.props.icon && <img className="text-input-icon" src={this.props.icon + "-icon.png"} alt="" />}
                <div style={{display: 'flex', flexDirection: 'column'}}>
                {!this.props.isEdit && this.props.subText && <span className="text-input-sub-text">{this.props.subText}</span>}
                {!this.props.isEdit && !this.props.asHtml && <span className="text-input-text">{this.props.text}</span>}
                {!this.props.isEdit && this.props.asHtml && <span className="text-input-text with-semicolon" dangerouslySetInnerHTML={this.createMarkup(this.props.text)} />}
                {this.props.isEdit && !this.props.isMobile && <input
                    autoFocus type="text"
                    className="text-input-input"
                    onChange={this.props.onDestinationInput}
                    placeholder={this.props.placeholder || getText('destinationFlightPlaceholder')} />}
                </div>
            </div>
        );
    }
}

TextInputLabel.propTypes = {
    //myProp: PropTypes.type.isRequired
};

export default TextInputLabel;


// WEBPACK FOOTER //
// ./src/components/TextInputLabel.js